// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__mw5zD","small":"Avatar_small__x6Sj2","medium":"Avatar_medium__IRHfN","large":"Avatar_large__yzSn2","xlarge":"Avatar_xlarge__Ayj8g"};